import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES } from '../../config/url.servicio'

@Injectable()
export class CargosProvider {

  constructor(public http: Http) {
    this.buscar()
  }

  buscar() {
    if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        return this.http.get(`${url_servicio}/procedure?name=cargos`);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=cargos`)
      .map((data) => data.json())
    }
  }

  buscarCargosPorEmpresa(companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarCargosPorEmpresa",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarCargosPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
    }
  }

  buscarCostosAdicionales(companiasId:any){
 let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarCostosAdicionales",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  buscarEntidadesPorEmpresa(companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarEntidadesPorEmpresa",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarEntidadesPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
    }
  }

  buscarTodo(name:string) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      return this.http.get(`${url_servicio}/procedure?name={name}`);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=${name}`)
      .map((data) => data.json())
    }
  }

  buscarContenedores(companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarContenedores",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarContenedores&companiasId=${companiasId}`)
      .map((data) => data.json())
    }
  }

  guardar(cargo: any) {
    if(NUBE_AWS) {
      const url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: cargo.name,
        parameters : {...cargo}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/query`, cargo, options)
        .map((data) => data.json())
    }
  }

  guardarTodo(datanew: any) {
    if(NUBE_AWS) {
      const url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: datanew.name,
        parameters : {...datanew}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option

      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.post(`${url}/query`, datanew, options)
        .map((data) => data.json())
    }
  }

  guardarCostosAdicionales(cargo: any) {
    if(NUBE_AWS) {
      const url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: cargo.name,
        parameters : {...cargo}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/query`, cargo, options)
        .map((data) => data.json())
    }
  }


  actualizar(values: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: values.name,
        parameters : {...values}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.put(`${url}/query`, values, options)
    }
  }

  actualizarTodo(datanew: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: datanew.name,
        parameters : {...datanew}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.put(`${url}/query`, datanew, options)
    }
  }


  eliminar(cargo: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: cargo.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          cargosId : cargo.cargosId,
          nombreTabla: "cargos"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&cargosId=${cargo.cargosId}&nombreTabla=cargos`, options)

    }
 }

 eliminarEntidades(entidad: any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: entidad.name,
      parameters : {
        name : "dataDynamicCrud",
        queHago: "E",
        entidadesId : entidad.entidadesId,
        nombreTabla: "entidades"
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })
    return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&entidadesId=${entidad.entidadesId}&nombreTabla=entidades`, options)

  }
}


eliminarCostosAdicionales(cargo: any) {
  let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: cargo.name,
      parameters : {
        name : "dataDynamicCrud",
        queHago: "E",
        costosAdicionalesId : cargo.costosAdicionalesId,
        nombreTabla: "costosAdicionales"
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

  eliminarContenedor(datanew: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: datanew.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          contenedorId : datanew.contenedorId,
          nombreTabla: "contenedor"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&contenedorId=${datanew.contenedorId}&nombreTabla=contenedor`, options)
   }
 }

 async validarCostosAdicionalesCambioFecha(companiasId: any) {
  try {
       let url_servicio = URL_SERVICIOS_AWS;
       let values = {
         name: "validarCostosAdicionalesCambioFecha",
         parameters : { companiasId}
       }
       let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
       let options = new RequestOptions({ headers: headers }) // Create a request option
       let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
       return response
 } catch (error) {
   console.error('Error al guardar la placa:', error);
   throw error;
 }
}


}



// WEBPACK FOOTER //
// ./src/providers/cargos/cargos.ts